import { useApi } from "@/lib/api";
import { Invoice } from "@/types/billing";

export function useInvoices(periodId: string | null) {
  return useApi<Invoice[]>(periodId ? `/api/invoice/${periodId}` : null, [periodId]);
}

export function useInvoice(periodId: string | null, agreementId: string | null) {
  const path = periodId && agreementId ? `/api/invoice/${periodId}/${agreementId}` : null;
  return useApi<Invoice>(path, [periodId, agreementId]);
}
